<template>
	<v-container fluid class="monitored-symptom-form">
		<v-form ref="form" v-model="valid">
			<v-row no-gutters>
				<v-col cols="12" sm="4" v-if="context == 'monitoringTab'">
					<v-autocomplete
						v-model="patientId"
						:search-input.sync="search"
						:items="patients"
						:filter="patientFilter"
						item-text="name"
						item-value="id"
						:label="$gettext('Patient')"
						clearable
						outlined
						no-data-text="No Patients found"
						prepend-inner-icon="person"
						class="px-2"
						required
						:rules="patientRules"
						@click:prepend-inner="goToPatient"
					/>
				</v-col>
				<v-col cols="12" sm="10" v-if="context == 'monitoringTab' || context == 'patientMonitoring'">
					<SearchICD class="px-2" :selectedICDSingle="symptom" context="monitoring" />
				</v-col>
				<v-col cols="12" sm="12">
					<v-text-field
						v-model="description"
						:label="$gettext('Title')"
						class="px-2"
						required
						outlined
					/>
				</v-col>
				<v-col cols="12" sm="12">
					<v-textarea
						v-model="info"
						:label="$gettext('Info')"
						class="px-2"
						required
						outlined
					/>
				</v-col>
				<v-col cols="12">
					<v-alert v-model="error" color="red lighten-4" icon="error" class="text-caption">
						<translate>Error! Try again later</translate>
					</v-alert>
					<v-alert v-model="exist" color="red lighten-4" icon="error" class="text-caption">
						<translate>This symptom is already being monitored by you.</translate>
					</v-alert>
				</v-col>
			</v-row>
		</v-form>
	</v-container>
</template>

<script>
//import SearchICD from "@/components/icd/SearchICD.vue";
import axios from "axios";

export default {
	name: "MonitoredSymptomForm",
	props: {
		patients: {
			default: () => []
		},
		patientId: {
			default: null
		},
		symptom: {
			default: () => ({ disease: null })
		},
		context: {}
	},
	components: {
		SearchICD: () => import("@/components/icd/SearchICD.vue")
	},
	data: () => ({
		valid: false,
		search: null,
		description: "",
		info: "",
		error: false,
		exist: false
	}),
	methods: {
		patientFilter(item, queryText) {
			const textOne = item.name.toLowerCase();
			const searchText = queryText.toLowerCase();

			return textOne.indexOf(searchText) > -1;
		},
		goToPatient() {
			if (this.patientId) {
				this.$router.push({
					name: "patient",
					params: { pid: this.patientId }
				});
			}
		},
		validateForm() {
			if (this.context == "patientMonitoring" && this.symptom.disease == null)
				return false;
			else return this.$refs.form.validate();
		},
		createMonitoredSymptom() {
			if (this.validateForm()) {
        this.error = false;
        this.exist = false;
				const formData = new FormData();
				formData.append("patient_id", this.patientId);
				formData.append("disease_id", this.symptom.disease.disease_id);
				formData.append("user_id", this.$store.getters.userId);
				formData.append("description", this.description);
				formData.append("info", this.info);
				formData.append("extension_codes", JSON.stringify(this.symptom.disease.active_extensions));
				axios
					.post(
						"/patient/" + this.patientId + "/monitored_symptoms/new",
						formData
					)
					.then(response => {
						if (response.data.result == "ok")
							this.$emit(
								"monitored-symptom-created",
								response.data.monitored_symptom
							);
						else if (response.data.result == "exist") this.exist = true;
						else this.error = true;
					})
					.catch(error => {
            console.log(error);
            this.error = true;
					});
			}
		}
	},
	computed: {
		patientRules() {
			return [v => !!v || this.$gettext("Patient is required")];
		}
	}
};
</script>